import i18next from "src/i18n/config";

import { createStreamSession } from "@dashboard/devices/api/stream";

export function getReasonMessage(props: {
    isSubscriptionExpired: boolean;
    isVncEnabled: boolean;
    hasOnlineDevice: boolean;
    limit: number;
}) {
    if (props.limit <= 0) {
        return i18next.t("common:section.logStreamer.streamLimitReached");
    }
    if (!props.hasOnlineDevice) {
        return i18next.t("sidepanels:devicePanel.tooltip.deviceOffline");
    }
    if (!props.isVncEnabled) {
        return i18next.t("sidepanels:devicePanel.tooltip.vncDisabled");
    }
    return i18next.t("sidepanels:devicePanel.tooltip.vncEnabled");
}

export async function openScreenViewPage(workspaceId: number): Promise<void> {
    const sessionId = await createStreamSession(workspaceId, "WebSocket");
    if (sessionId) {
        const params = new URLSearchParams({ sessionId });
        window.open(
            `${window.location.origin}/screenview?${params.toString()}`,
            "_blank",
            "width=1200,height=800,left=200,top=200",
        );
    }
}
